import React from 'react'

import Image from '../image'

type Props = { src: string, alt: string }
const ProfileLogo: React.FC<Props> = ({ src, alt }) => {
  return (
    <div className='bg-white inline-block rounded-xl sm:rounded-2xl w-[87px] sm:w-[171px] h-[51px] sm:h-[111px]'>
      <Image className='inline-block box-border p-1 sm:p-3 object-contain w-full h-full' src={src} alt={alt} />
    </div>
  )
}

export default ProfileLogo
